// Curated STORY-TEXT fonts — the body face of every scene page. The admin picks
// ONE globally (Admin → Settings → خط القصة) and it applies to both the printed
// PDF and this on-screen viewer, so what the customer reads is what gets printed.
//
// Keep IN SYNC with:
//   • STORY_FONTS in server/services/bookPdf.js (the print side)
//   • the storyBodyFont enum in server/db/models/Settings.js
//   • the Google Fonts <link> in client/public/index.html and in bookPdf.js htmlDoc()
import { api } from '../api/client';

export const STORY_FONTS = [
  { key: 'cairo',        label: 'Cairo — كايرو',                   css: "'Cairo', 'Segoe UI', system-ui, sans-serif" },
  { key: 'tajawal',      label: 'Tajawal — تجوّل',                  css: "'Tajawal', 'Cairo', system-ui, sans-serif" },
  { key: 'amiri',        label: 'Amiri — أميري (نسخ)',              css: "'Amiri', 'Cairo', serif" },
  { key: 'readex',       label: 'Readex Pro — ريدكس برو',           css: "'Readex Pro', 'Cairo', system-ui, sans-serif" },
  { key: 'rakkas',       label: 'Rakkas — رقّاص',                   css: "'Rakkas', 'Cairo', cursive" },
  { key: 'scheherazade', label: 'Scheherazade New — شهرزاد (نسخ)',  css: "'Scheherazade New', 'Amiri', 'Cairo', serif" },
  { key: 'marhey',       label: 'Marhey — مرحى',                    css: "'Marhey', 'Cairo', system-ui, sans-serif" },
];

export const DEFAULT_STORY_FONT_CSS = STORY_FONTS[0].css;

export function storyFontCss(key) {
  const f = STORY_FONTS.find((x) => x.key === key);
  return f ? f.css : null;
}

// Fetch the admin-chosen font once at boot and publish it as the --story-font
// CSS variable, which every `.scene-text` rule reads (App.css). Failure is
// silent: the var stays unset and the CSS fallback keeps Cairo, so a hiccup on
// /api/site-config can never leave the book unstyled.
export function initStoryFont() {
  api.get('/api/site-config')
    .then((cfg) => {
      const css = storyFontCss(cfg?.storyBodyFont);
      if (css) document.documentElement.style.setProperty('--story-font', css);
    })
    .catch(() => {});
}
